import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { TrustSection } from '../components/TrustSection';
import { AboutSection } from '../components/AboutSection';
import { ProgramsSection } from '../components/ProgramsSection';
import { LearningJourney } from '../components/LearningJourney';
import { CEOSection } from '../components/CEOSection';
import { FacultySection } from '../components/FacultySection';
import { UpcomingTraining } from '../components/UpcomingTraining';
import { IntelligenceHub } from '../components/IntelligenceHub';
import { GlobalPresence } from '../components/GlobalPresence';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Shield, Globe, Award, ArrowRight } from 'lucide-react';
import { GlassCard } from '../components/GlassCard';
export function Home() {
  return <div className="min-h-screen bg-background text-white font-body selection:bg-primary-blue/30" data-id="element-357">
      <Navbar data-id="element-358" />

      <main data-id="element-359">
        <Hero data-id="element-360" />
        <TrustSection data-id="element-361" />
        <AboutSection data-id="element-362" />
        <ProgramsSection data-id="element-363" />
        <LearningJourney data-id="element-364" />

        {/* Certification Prep Section */}
        <section className="py-24 bg-background-secondary/50" data-id="element-365">
          <div className="container mx-auto px-6" data-id="element-366">
            <div className="text-center mb-16" data-id="element-367">
              <h2 className="text-3xl md:text-5xl font-bold font-heading mb-6" data-id="element-368">
                Certification Preparation
              </h2>
              <p className="text-white/50 max-w-2xl mx-auto" data-id="element-369">
                We prepare you for the most recognized global certifications in
                the industry.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-370">
              {[{
              name: 'CISA',
              full: 'Certified Information Systems Auditor',
              color: 'text-blue-400'
            }, {
              name: 'Security+',
              full: 'CompTIA Security+',
              color: 'text-primary-blue'
            }, {
              name: 'HCISPP',
              full: 'Healthcare Information Security',
              color: 'text-accent-cyan'
            }, {
              name: 'CHPSE',
              full: 'Privacy & Security Expert',
              color: 'text-status-success'
            }].map((cert, i) => <motion.div key={cert.name} initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} data-id="element-371">
                  <GlassCard className="p-8 text-center group border-white/5 hover:border-primary-blue/30" data-id="element-372">
                    <div className={cn('text-3xl font-bold mb-2 font-heading', cert.color)} data-id="element-373">
                      {cert.name}
                    </div>
                    <div className="text-[10px] text-white/40 uppercase font-bold tracking-widest" data-id="element-374">
                      {cert.full}
                    </div>
                  </GlassCard>
                </motion.div>)}
            </div>
          </div>
        </section>

        <CEOSection data-id="element-375" />
        <FacultySection data-id="element-376" />

        {/* Mission Vision Values */}
        <section className="py-24" data-id="element-377">
          <div className="container mx-auto px-6" data-id="element-378">
            <div className="grid md:grid-cols-3 gap-8" data-id="element-379">
              {[{
              title: 'Mission',
              desc: 'To empower professionals with elite cybersecurity skills through immersive, industry-aligned training.',
              icon: Shield
            }, {
              title: 'Vision',
              desc: 'To be the global leader in cybersecurity education, shaping the future of digital resilience.',
              icon: Globe
            }, {
              title: 'Values',
              desc: 'Integrity, Excellence, Innovation, and a commitment to student success in everything we do.',
              icon: Award
            }].map((item, i) => <motion.div key={item.title} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: i * 0.1
            }} data-id="element-380">
                  <GlassCard className="p-10 h-full border-white/5" data-id="element-381">
                    <item.icon size={40} className="text-primary-blue mb-6" data-id="element-382" />
                    <h3 className="text-2xl font-bold text-white mb-4" data-id="element-383">
                      {item.title}
                    </h3>
                    <p className="text-white/50 leading-relaxed" data-id="element-384">{item.desc}</p>
                  </GlassCard>
                </motion.div>)}
            </div>
          </div>
        </section>

        <UpcomingTraining data-id="element-385" />
        <IntelligenceHub data-id="element-386" />
        <GlobalPresence data-id="element-387" />

        {/* CTA Section */}
        <section className="py-24 relative overflow-hidden" data-id="element-388">
          <div className="absolute inset-0 bg-primary-blue/10" data-id="element-389" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(24,99,220,0.2)_0%,transparent_70%)]" data-id="element-390" />

          <div className="container mx-auto px-6 relative z-10" data-id="element-391">
            <GlassCard className="p-12 md:p-20 text-center border-white/20 bg-primary-navy/40" data-id="element-392">
              <h2 className="text-4xl md:text-6xl font-bold font-heading text-white mb-8" data-id="element-393">
                Become Cyber Ready.
              </h2>
              <p className="text-xl text-white/70 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-394">
                Train with experienced professionals and build the expertise
                organizations are searching for. Join the next generation of
                security leaders.
              </p>
              <div className="flex flex-wrap justify-center gap-6" data-id="element-395">
                <button className="px-10 py-5 bg-primary-blue text-white font-bold rounded-full hover:bg-blue-600 transition-all shadow-2xl shadow-primary-blue/40 text-lg" data-id="element-396">
                  Apply Now
                </button>
                <button className="px-10 py-5 bg-white/5 border border-white/10 text-white font-bold rounded-full hover:bg-white/10 transition-all text-lg" data-id="element-397">
                  Speak with an Advisor
                </button>
              </div>
            </GlassCard>
          </div>
        </section>
      </main>

      <Footer data-id="element-398" />
    </div>;
}
import { cn } from '../utils/cn';